import moment from "moment";

export default function dateFilter(value) {
  if (moment(value, 'DD.MM.YYYY').isValid()) {
    return moment(value, 'DD.MM.YYYY').format('ddd, DD MMM YYYY HH:mm:ss [GMT]')
  } else {
    return value
  }
}
